import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import MessagingService from '@/services/api/messaging.service';

export function useUnreadMessageCount() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      loadUnreadCount();
      
      // MOBILE FIX: Skip subscription on mobile to prevent "Too many database timeouts" error
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        return undefined;
      }
      
      // Subscribe to conversation updates for real-time count updates (desktop only)
      const subscription = MessagingService.subscribeToConversations(() => {
        loadUnreadCount();
      });

      return () => {
        MessagingService.unsubscribeFromConversations();
      };
    } else {
      setUnreadCount(0);
      setLoading(false);
    }
  }, [user]);

  const loadUnreadCount = async () => {
    try {
      const response = await MessagingService.getUnreadMessageCount();
      if (response.success) {
        setUnreadCount(response.data);
      } else {
        console.error('Error loading unread message count:', response.error);
        setUnreadCount(0); // Set to 0 on error to prevent UI issues
      }
    } catch (error) {
      console.error('Error loading unread message count:', error);
      setUnreadCount(0); // Set to 0 on error to prevent UI issues
    } finally {
      setLoading(false);
    }
  };

  const refreshUnreadCount = () => {
    loadUnreadCount();
  };

  return {
    unreadCount,
    loading,
    refreshUnreadCount
  };
}